<template>
  <div>
    <Header v-if="$route.name !== 'login'"></Header>
    <Carousel :imgList="bannerList"></Carousel>
    <router-view></router-view>
    <Footer v-if="$route.name !== 'login'"></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Carousel from '@/components/Carousel'
import Footer from '@/components/Footer'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Dashboard',
  data () {
    return {
      // 轮播图列表
      bannerList: [
        {
          id: 0,
          imghref: require('../assets/images/banner/banner.png')
        },
        {
          id: 1,
          imghref: require('../assets/images/banner/banner_01.jpg')
        },
        {
          id: 2,
          imghref: require('../assets/images/banner/banner_02.jpg')
        },
        {
          id: 3,
          imghref: require('../assets/images/banner/banner_03.jpg')
        }
      ]
    }
  },
  components: {
    Header,
    Carousel,
    Footer
  },
  mounted () {
    this.router = this.$router
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
